import { useEffect, useRef } from "react";
import PortalReactDOM from "react-dom";

interface IProps {
  el?: string;
  children: React.ReactNode;
}

export const Portal: React.FC<IProps> = ({ children, el = "div" }: IProps) => {
  const container = useRef(document.createElement(el));

  useEffect(() => {
    document.body.appendChild(container?.current);
    return () => {
      document.body.removeChild(container?.current);
    };
  }, []);

  return PortalReactDOM.createPortal(children, container?.current);
};
